module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-poem"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('em', [_vm._v("By the Same Author:")])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "fm-poem1"
  }, [_vm._v("“SERGEANT BEEF” NOVELS:")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Case for Three Detectives")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Case without a Corpse")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Case with No Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Case with Four Clowns")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Case with Ropes and Rings")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Case for Sergeant Beef")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Cold Blood")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem2"
  }, [_vm._v("“CAROLUS DEENE” NOVELS:")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("At Death’s Door")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Death of Cold")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Death for a Ducat")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Dead Man’s Shoes")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("A Louse for the Hangman")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Our Jubilee is Death")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Jack on the Gallows Tree")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Furious Old Women")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("A Bone and a Hank of Hair")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Die All, Die Merrily")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Nothing Like Blood")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Such is Death")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem2"
  }, [_vm._v("CAROLUS DEENE “DEATH” NOVELS:")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Death at Hallows End")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Death on the Black Sands")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Death at St. Asprey’s School")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Death of a Commuter")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Death on Romney Marsh")]), _vm._v(" "), _c('p', {
    staticClass: "fm-poem0"
  }, [_vm._v("Death with Blue Ribbon")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95511134","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002_FM.vue
// module id = 63
// module chunks = 0